import { SubscriptionTier } from '@/../generated-client/models';

const TIER_LABEL_KEY: Record<SubscriptionTier, string> = {
  [SubscriptionTier.Connect]: 'Connect',
  [SubscriptionTier.Ops]: 'Ops',
  [SubscriptionTier.Respond]: 'Respond',
};

export const getTierLabelKey = (tier: SubscriptionTier): string => TIER_LABEL_KEY[tier];
